module.exports = "/cyber/_next/static/images/hitSteamSlide-905f906a57d9df153d3acc4bfb86a662.jpg";